module.exports = __webpack_public_path__ + "img/multi_daños.4b406057.svg";